import { z } from "zod";

import { MaterialTypeEnum, PlateTypeEnum } from "@ns/types";

export const createCodebookSchema = z.object({
  code: z.string(),
  name: z.string(),
  type: z.array(z.nativeEnum(MaterialTypeEnum)),
  plateType: z.array(z.nativeEnum(PlateTypeEnum)),
  note: z.string().optional(),
  stoneSurfaceTreatment: z.string().optional(),
});

export type CreateCodebook = z.infer<typeof createCodebookSchema>;
